const getGlobalStore = () => window.eccubeTokenBalanceStore ?? null;

export const fetchTokenBalances = () => {
  const store = getGlobalStore();
  if (store === null) {
    return Promise.reject(new Error('Token balance store is unavailable.'));
  }

  return store.fetch();
};

export const subscribeTokenBalances = (subscriber) => {
  const store = getGlobalStore();

  return store === null ? () => {} : store.subscribe(subscriber);
};

export const updateTokenBalances = (result) => {
  const store = getGlobalStore();
  if (store !== null) {
    store.update(result);
  }
};

export const consumeTokenBalances = (consumedBalances, totalQuantity) => {
  const store = getGlobalStore();
  if (store !== null) {
    store.consume(consumedBalances, totalQuantity);
  }
};

export const tokenBalanceStore = {
  fetch: fetchTokenBalances,
};
